import { CameraConfig, ModelBased, ModelBasedVisual } from "./ModelBasedVisual";
import { Visual } from "../models/Visual";
import { BaseAnimator } from "./BaseAnimator";
import { QRAnimator } from "./QRAnimator";
import { loadOrgModel } from "../api/connection";
import { createRobot, Robot, RobotManifest } from "../models/Robot";
import yaml from 'js-yaml';
import { toEuler, toVector3 } from "./visual-utils";

export interface RobotData extends ModelBased {
  robotId: string; // ID of the associated quadruped robot model
  visualizeSensors: boolean;
}



export abstract class RobotVisual extends ModelBasedVisual implements RobotData {
  public robotId: string = ''; // Initialize robotId
  public robot!: Robot;
  public visualizeSensors: boolean = true;
  public manifest?: RobotManifest;

  constructor() {
    super();
  }

  public getType(): string {
    return 'RobotVisual';
  }

  public createDataTemplate(): Visual {
    const data: RobotData = {
      type: this.getType(),
      _id: this._id,
      id: this.id,
      position: this.position,
      rotation: this.rotation,
      orgId: this.orgId,
      siteAnchorId: this.siteAnchorId,
      modelId: this.modelId,
      robotId: this.robotId,
      location: this.location,
      visualizeSensors: this.visualizeSensors,
      floorId: this.floorId,
    };
    return data;
  }

  protected async onLoaded() {
    if (!this.robotId) return;
    this.robot = await loadOrgModel(createRobot(this.robotId));
    this.manifest = yaml.load(this.robot.yamlContent) as RobotManifest;
  }

  public getActorProps() {
    return {
      robotId: this.robotId
    };
  }

  public createAnimator(): BaseAnimator {
    return new QRAnimator(this.modelLoader);
  }

  public getCameras(): CameraConfig[] {
    if (this.manifest?.cfg?.sensors) {
      const cams: CameraConfig[] = [];
      for (const [key, sensor] of Object.entries(this.manifest.cfg.sensors)) {
        if (key.startsWith('video')) {
          const parentObj = sensor.parent ? this.obj.getObjectByName(sensor.parent) : this.obj;
          // console.log(({ key, sensor, parent: parentObj }));
          const cam: CameraConfig = {
            name: key,
            position: toVector3(sensor.position),
            rotation: toEuler(sensor.rotation),
            fov: sensor.fov || 70,
            parent: parentObj!
          };
          if (sensor.gimbal) {
            cam.gimbal = toEuler(sensor.gimbal);
          }
          cam.rotation.order = 'YXZ';
          cams.push(cam);
        }
      }
      return cams;
    }
    return [];
  }

}